import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';
import { GestaoPaginaEnum } from '../models/gestaoPagina.model';

@Injectable({
  providedIn: 'root',
})
export class GestaoPaginaService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) {}

  list(params?: any): Observable<any> {
    return this.apiService
      .get(
        `/GestaoPagina`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params,
      )
      .pipe(map((response) => response));
  }

  listPublic(params?: any): Observable<any> {
    return this.apiService
      .get(
        `/GestaoPagina/Dominio`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params,
      )
      .pipe(map((response) => response));
  }

  /**
   * Cria um novo item
   * @param payload
   * @returns Observable<any>
   */
  public store(payload: any): Observable<any> {
    return this.apiService.post(`/GestaoPagina`, payload);
  }

  /**
   * atualizar item de conteudo
   * @param payload
   * @returns Observable<any>
   */
  public update(payload: any): Observable<any> {
    return this.apiService.put(`/GestaoPagina`, payload);
  }

  show(id: string): Observable<any> {
    return this.apiService
      .get(`/GestaoPagina/${id}`)
      .pipe(map((response) => response));
  }

  delete(id: string): Observable<any> {
    return this.apiService.delete(`/GestaoPagina/${id}`);
  }

  public getByEnum<T>(GestaoPaginaENUM: GestaoPaginaEnum): Observable<T> {
    return this.listPublic({ GestaoPaginaENUM: GestaoPaginaENUM }).pipe(
      map((response) => response.data[0]?.valor),
    );
  }

  // Estrutura principal
  public getHeader(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.Header);
  }

  public getTituloPrincipal(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.TituloPrincipal);
  }

  public getSubtitulo(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.Subtitulo);
  }

  public getBannerPrincipal(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.BannerPrincipal);
  }

  // Secções institucionais
  public getSobre(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.Sobre);
  }

  public getServicos(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.Servicos);
  }

  public getParceiros(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.Parceiros);
  }

  public getTestemunhos(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.Testemunhos);
  }

  public getGaleria(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.Galeria);
  }

  public getEventos(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.Eventos);
  }

  // Conversão
  public getCallToAction(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.CallToAction);
  }

  // Rodapé
  public getRodape(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.Rodape);
  }

  public getContactos(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.Contactos);
  }

  public getRedesSociais(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.RedesSociais);
  }

  // Identidade institucional
  public getMissao(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.Missao);
  }

  public getValores(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.Valores);
  }

  public getVisao(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.Visao);
  }

  public getPropositoFundcube(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.PropositoFundcube);
  }

  // FAQ
  public getPerguntasFrequentes(): Observable<string> {
    return this.getByEnum<string>(GestaoPaginaEnum.PerguntasFrequentes);
  }
}